import React, { useEffect, useState } from "react";
import "../../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import UserComment from "../UserComment";
import {
  setDocViewTableData,
  setSelectedMatched,
  setSelectedRowMatched,
} from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
 
const Table = (props) => {
  const dispatch = useDispatch();
 
  const {
    selectedMatched,
    docViewTableData,
    totalPageMatched,
    pageNoMatched,
    selectedRowMatched,
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const [open, setOpen] = useState(false);
  const [commentRow, setCommentRow] = useState([]);
 
  const userCommentsFormatter = (cell, row) => {
    return (
      <div
        style={{
          width: "100%",
          cursor: "pointer",
          textDecoration: "underline",
          color: "#4f2d7f",
        }}
        onClick={() => {
          console.log("row::", row.TXN_ID);
          setCommentRow(row);
          setOpen(true);
        }}
      >
        {"Link"}
      </div>
    );
  };
 
  const handleCloseComment = () => {
    setOpen(false);
    setCommentRow([]);
  };
 
  const columns = [
    {
      dataField: "ORIGINAL_MATCH_TYPE",
      text: "Original Match Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) =>
        displayNullFormatter(row, "ORIGINAL_MATCH_TYPE"),
    },
    {
      dataField: "SUBCATEGORY",
      text: "Base Data",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "SUBCATEGORY"),
    },
    {
      dataField: "GSTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN_PURCHASE"),
    },
    {
      dataField: "GSTIN",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "CTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_PURCHASE"),
    },
    {
      dataField: "CTIN_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_SALE"),
    },
    {
      dataField: "INUM_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_PURCHASE"),
    },
    {
      dataField: "INUM_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_SALE"),
    },
    {
      dataField: "IDT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_PURCHASE"),
    },
    {
      dataField: "IDT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_SALE"),
    },
    {
      dataField: "POS_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_PURCHASE"),
    },
    {
      dataField: "POS_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_SALE"),
    },
    {
      dataField: "TXVAL_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_PURCHASE"),
    },
    {
      dataField: "TXVAL_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_SALE"),
    },
    {
      dataField: "IAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_PURCHASE"),
    },
    {
      dataField: "IAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_SALE"),
    },
    {
      dataField: "CAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_PURCHASE"),
    },
    {
      dataField: "CAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_SALE"),
    },
    {
      dataField: "SAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_PURCHASE"),
    },
    {
      dataField: "SAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_SALE"),
    },
    {
      dataField: "CSAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_PURCHASE"),
    },
    {
      dataField: "CSAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_SALE"),
    },
    {
      dataField: "RETURN_PERIOD",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RETURN_PERIOD"),
    },
    {
      dataField: "RET_PERIOD",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "GSTR2B_PERIOD",
      text: "GSTR-2B Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTR2B_PERIOD"),
    },
    {
      dataField: "RET_PERIOD",
      text: "Matched Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => {
        // Show Matched Month only when reconciliation status is 'Matched'
        if (!row || String(row.STATUS_TYPE) !== "Matched") return "";
        // Prefer RET_PERIOD when available, otherwise fall back to RETURN_PERIOD
        const ret = row && row.RET_PERIOD;
        if (ret !== undefined && ret !== null && String(ret).trim() !== "") {
          return displayNullFormatter(row, "RET_PERIOD");
        }
        return displayNullFormatter(row, "RETURN_PERIOD");
      },
    },
    {
      dataField: "ITC_AVAILABILITY",
      text: "ITC Availability as per 2B",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_AVAILABILITY"),
    },
    {
      dataField: "ITC_UNAVAILABILITY_REASON",
      text: "ITC Un-availability as per 2B reason",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_UNAVAILABILITY_REASON"),
    },
    {
      dataField: "MARK_AS_THREEB",
      text: "3B Availed",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "MARK_AS_THREEB"),
    },
    {
      dataField: "THREEB_MONTH",
      text: "3B Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "THREEB_MONTH"),
    },
    {
      dataField: "THREEB_ITC_TYPE",
      text: "ITC Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "THREEB_ITC_TYPE"),
    },
    {
      dataField: "USER_COMMENTS",
      text: "User Comments",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.125%",
      },
      // formatter: (col, row) => {
      //   return (
      //     <div
      //       style={{
      //         width: "100%",
      //         cursor: "pointer",
      //         textDecoration: "underline",
      //         color: "#4f2d7f",
      //       }}
      //       onClick={() => setOpen(true)}
      //     >
      //       {"Link"}
      //     </div>
      //   );
      // },
      formatter: userCommentsFormatter,
    },
  ];
  function handleOnSelect(row, isSelect) {
    console.log("handleOnSelect called");
    if (isSelect) {
      console.log("inside if");
      dispatch(setSelectedMatched([...selectedMatched, row.TXN_ID]));
      dispatch(setSelectedRowMatched([...selectedRowMatched, row]));
    } else {
      console.log("inside else");
      let selected = [...selectedMatched];
      selected.splice(selected.indexOf(row.TXN_ID), 1);
      dispatch(setSelectedMatched(selected));
      const updatedRows = selectedRowMatched.filter(
        (r) => r.TXN_ID !== row.TXN_ID
      );
      dispatch(setSelectedRowMatched(updatedRows));
    }
  }
 
  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      dispatch(setSelectedMatched(ids));
      dispatch(setSelectedRowMatched(rows));
    } else {
      dispatch(setSelectedMatched([]));
      dispatch(setSelectedRowMatched([]));
    }
  }
  const selectRow = {
    mode: "checkbox",
    selected: selectedMatched,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };
  useEffect(() => {
    // console.log("totalPageMatched ::", totalPageMatched);
    console.log("pageNoMatched ::", pageNoMatched);
   // console.log("selectedMatched ::", selectedMatched);
  }, [pageNoMatched, totalPageMatched, selectedMatched]);
  useEffect(() => {
    return () => {
      dispatch(setSelectedMatched([]));
      dispatch(setDocViewTableData([]));
    };
  }, []);
 
  return (
    <>
      {docViewTableData?.length > 0 ? (
        <>
          {" "}
          <div
            id="tableDiv-scroll"
            className="light-border-gstr2a2bnew-table"
            style={{ maxHeight: "500px" }}
          >
            <div
              style={{
                display: "flex",
                width: "450%",
              }}
            >
              <div style={{ backgroundColor: "#4F2D7F", width: "7%" }}></div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "6.2%",
                }}
              >
                Recipient GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "6.2%",
                }}
              >
                Supplier GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "6.2%",
                }}
              >
                Document Number
              </div>
 
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                Document Date
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                POS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                Taxable Value
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                IGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                CGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                SGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                CESS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "6.2%" }}>
                Tax Period
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{ width: "24.8%" }}
              ></div>
            </div>
 
            <BootstrapTable
              keyField="TXN_ID"
              data={docViewTableData}
              columns={columns}
              rowStyle={rowStyle2}
              selectRow={selectRow}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPageMatched}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={pageNoMatched > 0 ? pageNoMatched - 1 : 0}


          />
        </>
      ) : (
        <NoData />
      )}
 
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"User Comment"}</Typography>
            <CloseIcon
              onClick={handleCloseComment}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div>
            <UserComment commentRow={commentRow} handleSubmit={props.handleSubmit} handleCloseComment={handleCloseComment}/>
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};
 
export default Table;
 
 